// extracted by mini-css-extract-plugin
module.exports = {"supporterTitle":"jgp-QqAto","donationMessage":"jgp-3eTwC","donationTimestamp":"jgp-bERxz","donationAmount":"jgp-19-fQ","donationAmount--gift-aid":"jgp-2d2XJ"};